export default __webpack_public_path__ + "static/media/background2.540fa6d6.jpg";